/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class Address
 */
export class Address {
  private readonly name!: string;
  private readonly street!: string;
  private readonly zip!: number;

  public getName(): string {
    return this.name;
  }

  public getStreet(): string {
    return this.street;
  }

  public getZip(): number {
    return this.zip;
  }

  public getFull(): string {
    return `${this.zip} ${this.street} ${this.name}`;
  }

  public get displayName(): string {
    return `${this.street} ${this.name}`;
  }
}
